//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('freightRateSetCreate', {
//        templateUrl: 'views/components/views/freightRateSetCreate/freightRateSetCreate.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'freightRateSetCreateService', 'logisticService', function ($stateParams, stateService, utilityService, modalService, translateService, freightRateSetCreateService, logisticService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let custNo = $stateParams.cust_no;
            
//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListCompanies: [],
//                selectListStockPlaces: [],
//                lockedSave: false
//            };
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await freightRateSetCreateService.getFreightRateSetCreate({ cust_no: custNo }))[0];
//            }
            
//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }
            
//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.edit.businessco_no, true) !== true) return;
                
//                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.edit.businessco_no });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                freightRateSetCreateService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.businessco_no) !== true) return;

//                        vm.model.edit.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.businessco_no, true) !== true) return;

//                        loadStockPlaces();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS
            
//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadCompanies();
//                loadStockPlaces();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
